// @flow
import React, { Component } from 'react'
import AjaxStateSwitcher from '../controls/AjaxStateSwitcher'
import AjaxDeleteButton from '../controls/AjaxDeleteButton'
import ProviderStatuses from './ProviderStatuses'
import StateSwitcher from '../controls/StateSwitcher'
import StatisticsCells from './StatisticsCells'
import styled, { type StyledComponent } from 'styled-components'
import { editPath as advertisementTemplateEditPath } from '../AdvertisementTemplatesTable'
import { NameLink, BodyRow, Cell, MenuItem, Tooltip } from '../MainTable'
import Menu from '../CampaignsTable/Menu'
import Checkbox from '../controls/Checkbox'
import AdImagePreview from '../controls/AdImagePreview'
import _ from 'lodash'
import type { Advertisement, AdvertisementStatistics } from '../AdvertisementsTable'
import classNames from 'classnames'

const Tr: any = styled(BodyRow)`
  ${(props: any) => (props.isBright ? 'background-color: #ffe' : '')};
`
const MenuWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-left: 6px;
`
const Inner: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  align-items: center;
`
const TextWrapper: StyledComponent<Object, any, any> = styled.div`
  flex-grow: 1;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  max-width: 250px;
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  color: #000;
`
const MenuLink: StyledComponent<Object, any, any> = styled.a`
  text-decoration: none;
`

type Props = {|
  isProductAudience: boolean,
  isPromotionAudience: boolean,
  onArchive: Function,
  onArchivationRollback: Function,
  onDetachFromTemplate: Function,
  onAdvertisementCheckboxChange: Function,
  onAdvertisementStateChange: Function,
  advertisementCheckboxChecked: boolean,
  activateUrl: string,
  deactivateUrl: string,
  archiveUrl: string,
  advertisement: Advertisement,
  statistics: Array<AdvertisementStatistics>,
  campaignName: string,
  audienceEditPath: string,
  audienceName: string
|}

const t = {
  copy: 'Копировать',
  detach_from_template: 'Отвязать от шаблона',
  archivate: 'Перенести в архив',
  based_on_template: 'Основано на шаблоне'
}

export default class Row extends Component<Props> {
  t: Function

  // React should perform similar check on its own, but doesn't
  shouldComponentUpdate(nextProps: Props) {
    return (
      !_.isEqual(this.props.advertisement, nextProps.advertisement) ||
      !_.isEqual(this.props.statistics, nextProps.statistics) ||
      this.props.advertisementCheckboxChecked !== nextProps.advertisementCheckboxChecked
    )
  }

  render() {
    const props = this.props
    const {
      advertisement,
      statistics,
      isProductAudience,
      isPromotionAudience,
      onArchive,
      onArchivationRollback,
      advertisementCheckboxChecked,
      activateUrl,
      deactivateUrl,
      archiveUrl
    } = this.props
    const { paths, picture, title, description } = advertisement

    return (
      <Tr
        isBright={!!advertisement.advertisement_template_id}
        key={props.advertisement.id}
        className={classNames({
          off: !this.props.advertisement.active,
          't-BasedOnTemplate': advertisement.advertisement_template_id
        })}
      >
        <Cell>
          <Checkbox
            className="t-AdvertisementRowCheckbox"
            onChange={(checked) => {
              this.props.onAdvertisementCheckboxChange(checked)
            }}
            checked={advertisementCheckboxChecked}
          />
        </Cell>
        <Cell alignRight>
          <AjaxStateSwitcher
            switcherComponent={StateSwitcher}
            checked={this.props.advertisement.checked}
            activateUrl={activateUrl}
            deactivateUrl={deactivateUrl}
            requestParams={{ ids: [props.advertisement.id] }}
            onResponse={(response) => this.props.onAdvertisementStateChange(response.data)}
          />
        </Cell>
        <Cell>
          <Inner>
            {!isProductAudience && !isPromotionAudience && (
              <AdImagePreview pictureUrl={picture || ''} />
            )}
            <TextWrapper>
              <NameLink href={paths.editPath}>
                {advertisement.advertisement_template_id ? (
                  <Tooltip
                    isInteractive
                    content={
                      <span>
                        {t.based_on_template}{' '}
                        <a
                          href={advertisementTemplateEditPath(
                            advertisement.advertisement_template_id
                          )}
                        >
                          #{advertisement.advertisement_template_id}
                        </a>
                      </span>
                    }
                  >
                    {title}
                  </Tooltip>
                ) : (
                  title
                )}
              </NameLink>
              {!isPromotionAudience && <Text>{description}</Text>}
            </TextWrapper>
          </Inner>
        </Cell>
        <Cell>
          <ProviderStatuses
            {...this.props.advertisement.statusesProps}
            id={props.advertisement.id}
            onProviderStatusesChange={(response) =>
              this.props.onAdvertisementStateChange([response.data])
            }
          />
        </Cell>
        <StatisticsCells statistics={statistics} />
        <Cell>
          <MenuWrapper>
            <Menu isMuted={!this.props.advertisement.active} className="t-AdvertisementRowMenu">
              <MenuLink href={paths.copyPath}>
                <MenuItem>{t.copy}</MenuItem>
              </MenuLink>
              {advertisement.advertisement_template_id && (
                <MenuItem>
                  <AjaxDeleteButton
                    url={paths.detachFromTemplateUrl}
                    onSuccess={() => this.props.onDetachFromTemplate()}
                  >
                    {t.detach_from_template}
                  </AjaxDeleteButton>
                </MenuItem>
              )}
              <MenuItem>
                <AjaxDeleteButton
                  url={archiveUrl}
                  requestParams={{ ids: [props.advertisement.id] }}
                  onStart={() => onArchive()}
                  onFail={() => onArchivationRollback()}
                >
                  {t.archivate}
                </AjaxDeleteButton>
              </MenuItem>
            </Menu>
          </MenuWrapper>
        </Cell>
      </Tr>
    )
  }
}
